import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silencia SOMENTE erros cross-origin opacos ("Script error." sem objeto de erro),
// tipicamente lançados por scripts de terceiros injetados no preview (não pelo nosso
// bundle same-origin). Não afeta erros reais da aplicação, que trazem `event.error`.
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    if (event.message === "Script error." && !event.error && !event.filename) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
